<template>
    <div class="container">
        <MainHeader :connected="false"/>
        <main class="content" :class="customBackgroundOnLogin" role="main">
            <slot/>
        </main>
        <Footer :connected="false"/>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MainHeader from '@/components/layout/MainHeader.vue';
import Footer from '@/components/layout/Footer.vue';

export default defineComponent({
    name: 'LayoutWithoutNav',
    components: {MainHeader, Footer},
    computed: {
        customBackgroundOnLogin() {
            return this.$route.path === '/login' ? 'white-background' : '';
        }
    }
});
</script>

<style scoped>
.container{
    max-height: 100vh;
}
.content{
    display: flex;
    box-sizing: border-box;
    min-height: calc(100vh - 110px);
    padding: 2vh 30px;
    justify-content: center;
    align-items: center;
    background-color: var(--background);
}
.white-background {
    background-color: var(--white);
}
:deep(.en-tete) {
    background-color: var(--white);
}
</style>
